"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.jwtToBitloopsUser = exports.isGoogleServerless = exports.isTokenExpired = exports.isBrowser = exports.wait = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const wait = (ms) => new Promise((resolve) => {
    setTimeout(resolve, ms);
});
exports.wait = wait;
const isBrowser = () => typeof window !== 'undefined';
exports.isBrowser = isBrowser;
/**
 * Parses the encoded JWT token and checks for its expiry
 *
 * @param token string, encoded jwt
 * @returns boolean, indication of whether the token is expired
 * or not
 */
const isTokenExpired = (token) => {
    const jwtData = (0, jwt_decode_1.default)(token);
    const { exp } = jwtData;
    // console.log('expires at: ', new Date(exp * 1000));
    const isExpired = Date.now() >= exp * 1000;
    return isExpired;
};
exports.isTokenExpired = isTokenExpired;
const isGoogleServerless = () => {
    if (process.env.K_SERVICE)
        return true;
    return false;
};
exports.isGoogleServerless = isGoogleServerless;
const jwtToBitloopsUser = (jwtData, token, refreshToken, providerId) => {
    var _a;
    return ({
        accessToken: token,
        refreshToken,
        sessionState: jwtData.session_state,
        uid: jwtData.sub,
        displayName: (_a = jwtData.name) !== null && _a !== void 0 ? _a : jwtData.preferred_username,
        firstName: jwtData.given_name,
        lastName: jwtData.family_name,
        email: jwtData.email,
        emailVerified: jwtData.email_verified,
        isAnonymous: false,
        providerId,
        clientId: jwtData.azp,
        photoURL: jwtData.photoURL,
    });
};
exports.jwtToBitloopsUser = jwtToBitloopsUser;
//# sourceMappingURL=helpers.js.map